<script setup lang="ts">
import { useFormContainer } from "~/composables/useFormContainer";
import FormCard from "~/components/ui/FormCard.vue";
const locale = await getLocale("forms", "club_warning");
import { computed } from 'vue';
import { useState } from '#app';
import Perks from "~/components/static/Perks.vue";

defineComponent({
  name: "ClubWarning",
});

defineProps({
  progress: { type: Number, required: true },
  title: { type: String, required: true },
  stickyButton: { type: Boolean, default: false }
});

const { FormContainer } = useFormContainer();

const name = useState("name", () => 'Nome utente');

const dynamicDescription = computed(() => {
  return `${name.value}, ${locale.description2}`;
});

const emit = defineEmits(["init", "submit", "decline"]);

onMounted(() => emit("init"));

</script>

<template>
  <FormContainer :progress="progress">
    <FormCard :title="title" @submit="emit('submit')" :has-sticky-button="stickyButton" header-class="pageTitle mb-4">
      <div class="w-full grid grid-col-1 md:grid-cols-12 gap-4">
        <p class="md:col-span-8 md:py-4 -mt-2" v-html="locale.description" />
        <div class="flex gap-4 md:col-span-4 border rounded-xl p-3">
          <img src="../../public/images/static/EPdA-Logo-2025_rgb.png" class="h-24" alt="logo prodotto dell'anno">
          <span class="-ms-3 -mt-1">*</span>
          <p class="-mt-1 md:-mt-1.5 text-sm md:text-base" v-html="dynamicDescription" />
        </div>
         <div class="spacer h-6" />
      </div>
      <template #link>
        <div class="text-center text-gray-700 text-sm my-4">
          <button data-testid="decline" class="underline" type="button" @click="emit('decline')">
            {{ locale.proceed_without_club }}
          </button>
        </div>
        <div class="spacer h-6" />
      </template>
    </FormCard>
    <template #bottom-out>
      <p class="italic px-4">{{ locale.disclaimer }}</p>
    </template>
  </FormContainer>
  <Perks />
</template>

<style scoped>
/* @media screen and (max-width: 639px) {
  div :deep(.form-header) {
    font-size: 1rem !important;
  }
} */
</style>
